export interface MasterRankingInfo {
    MasterRankingInfo: Array<MasterRankingData>;
    NickNameInfo: Array<NickNameData>;
}

export interface MasterRankingData {
    CustId: number;
    CustName: string;
    Ranking: number;
    WinningRate?: number
    BettingRate?: number;
    RecommendList: Array<RecommendData>;
    ParlayRecommendList?: Array<RecommendData>;
    BettingAnalysisList: Array<BettingAnalysisList>;
    SiteId: number;
}

export interface NickNameData {
    IBCCustId: number;
    NickName: string;
    UserName: string;
}

export interface BettingAnalysisList {
    Ranking: number;
    BetTypeId: number;
    Percentage: string;
}

export interface RecommendData {
    MatchId: number;
    MarketId: Array<number>;
    UserMarketId: number;
    MarketType: string;
    BetTeam: string;
    BetType: number;
    LiveScore: string;
    KickoffTime: string;
    IsClose: boolean;
    Stake: number;
    BetTime: string;
    TransId: string;
    RefNo?: string;
    Hdp1: number;
    Hdp2: number;
}

export interface HotMatchData {
    SportId: number;
    MatchId: number;
    EventTime: string;
    MarketType: string;
    BetTypeList: Array<MatchBetTypeData>;
}

export interface MatchBetTypeData {
    MarketId: number;
    BetType: number;
    BetTeam: string;
    BetCount: number;
}

export interface HotBettingData {
    SportId: number;
    MatchId: number;
    MarketId: number;
    MarketType: string;
    BetTeam: string;
    BetType: number;
    BetCount: number;
    Hdp1: number;
    Hdp2: number;
}

export interface JackPotByMatchInfoData {
    TotalPrize: number;
    MatchId: number;
}

export interface JackpotMatchInfoData {
    IsLive: boolean;
    HomeName: string;
    HomeId: number;
    AwayName: string;
    AwayId: number;
    TotalPrize: number;
    MatchId: number;
    GlobalMatchTime: string;
    UserCount: number;
    HasInvolved: boolean;
}

export interface JackpotMatchInfoPrizeData {
    PrizeList : Array<MatchListPrizeResponseData>;
    PrizeCustomerList : Array<MatchPrizeCustomerListResponseData>;
}

export interface JackpotEnableMatchListData {
    MatchId: number;
    GlobalMatchTime: string;
}

export interface MatchListPrizeResponseData {
    MatchId: number;
    TotalPrize: number;
    GlobalMatchTime: string;
    AwardedTime: string;
    HomeId: number;
    AwayId: number;
    HomeName: string;
    AwayName: string;
}

export interface MatchPrizeCustomerListResponseData {
    MatchId: number;
    SiteId: number;
    OriginalRanking: number;
    ActualRanking: number;
    CustId: number;
    CustName: string;
    Percentage: number;
    SabaCoin: number;
    NickName: string;
}

export enum PackPopupType {
	Notify = 0,
	Tutorial = 1,
	RedDot = 2,
	IncomingVoucher = 3,
	KingBackWinner = 4,
	RevisionTutorial = 5,
	VsTournament = 6,
    DontShowAgainToday = 7,
}

export type PackPopupState = {
	IsShow: boolean;
	PopupType: PackPopupType;
};

export type EventPackPopupStates = Array<PackPopupState>;

export interface CwcUserBetAmountData {
	Amount: number;
	Stage: number;
	IsExceed: boolean;
}

export const cwcPackBetRewardStages = [
	{ stage: 0, threshold: 0 },
	{ stage: 1, threshold: 80 },
	{ stage: 2, threshold: 200 },
	{ stage: 3, threshold: 350 },
] as const;